import { getCookie } from 'react-use-cookie';

const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export const Ga4Group = 'ga4';

export const trackEvent = (name, params) => {
  if (!window.gtag || !measurementId) return;

  window.gtag('event', name, { ...params, send_to: measurementId });
};

export const setUser = ({ userId, properties }) => {
  if (!window.gtag || !measurementId) return;

  window.gtag('config', measurementId, {
    groups: Ga4Group,
    send_page_view: false,
    user_id: userId,
    user_properties: properties,
  });
};

const getField = (field) =>
  new Promise((resolve) => {
    if (!window.gtag || !measurementId || !getCookie('_ga')) return resolve(null);

    window.gtag('get', measurementId, field, (value) => {
      resolve(typeof value === 'string' ? value : null);
    });
  });

export const getClientId = () => getField('client_id');

export const getSessionId = () => getField('session_id');
